<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Paragraph" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
export let label = "";
export let size = "md";
export let css = "";
export let align = "left";
export let color = "dark";
const HAS_SLOT = "default" in $$slots;
</script>

{#if HAS_SLOT || Boolean(label)}
    <p class = { `s8-${ size } s8-${ color } ${ css }` } style = { `--paragraph-align: ${ align }` }>
        {#if HAS_SLOT }
            <slot>Hello World</slot>
        {/if}
        {#if label !== undefined}
            { $t(label) }
        {/if}
    </p>
{/if}

<style>
    p {
        text-align: var(--paragraph-align);
    }

    p.s8-error {
        color: #EF233B;
    }

    p.s8-warning {
        color: #EFC923;
    }

    p.s8-success {
        color: #44835F;
    }

    p.s8-info {
        color: #446083;
    }

    p.s8-subtle {
        color: #979691;
    }

    p.s8-dark {
        color: #272711;
    }

    p.s8-light {
        color: #FFFFFF;
    }

    p.s8-lg {
        font-size: 14px;
        margin-bottom: 10px;
    }

    p.s8-md {
        font-size: 12px;
        margin-bottom: 10px;
     }

    p.s8-sm {
        font-size: 10px;
        margin-bottom: 10px;
    }</style>